import { create } from 'zustand'

interface ModalState {
   isPurchaseCreditModalOpen: boolean
   openPurchaseCreditModal: () => void
   closePurchaseCreditModal: () => void
}

export const usePurchaseCreditModalStore = create<ModalState>((set) => ({
   isPurchaseCreditModalOpen: false,
   openPurchaseCreditModal: () => set({ isPurchaseCreditModalOpen: true }),
   closePurchaseCreditModal: () => set({ isPurchaseCreditModalOpen: false }),
}))
